<template>
    <div class="comp-header" v-if="compDetail.compName">
        <div class="header-content">
            <div class="comp-detail">
                <comp-icon class="comp-logo" :src="compDetail.CompLogo" :width="147" :height="60"></comp-icon>
                <div class="comp-name">
                    <p>{{compDetail.CompName}}</p>
                    <p class="text-clamp2">{{compDetail.MainProduct}}</p>
                </div>
            </div>
            <div class="menu-view">
                <div
                    class="menu-item"
                    :class="activeKey === item.key ? 'active' : ''"
                    :name="item.key"
                    v-for="item in tabs"
                    :key="item.key"
                ><router-link class="m-tab-label" :to="`${item.url}${compID}`">{{item.name}}</router-link></div>
                <div class="comp-phone">技术咨询 {{compDetail.phone}}</div>
            </div>

            <product-qrcode
                v-if="compDetail.compId"
                :compID="compDetail.compId"
                :compLogo="compDetail.compLogo"
                textColor="#334161"
            ></product-qrcode>
        </div>
        <div class="banner-content">
            <div class="mask"></div>
            <img :src="compMainBanner" alt="">
        </div>
    </div>
</template>

<script>
    import { CompService,ApiService } from '@/service'
    
    import CompIcon from '@/components/icon/comp-icon.vue';
    import CustomerList from './customer.vue';
    import ProductQrcode from './product-qrcode.vue'
    import DirSelector from '@/components/dir-selector/index.vue'
    import VipLevel from "@/components/icon/vip-level.vue";

    export default{
        components: { CompIcon, CustomerList, DirSelector, VipLevel, ProductQrcode },
        props: {
            compID: { default: 0 },
            activeKey: { default: '' },
            className: { default: '' },
        },
        data() {
            return {
                searchKeyword: '',
                tabs: [
                    { key: 'lbj', name: '产品中心', url: '/product/list/' },
                    { key: 'lxwm', name: '联系我们', url: '/company/contact/' },
                    { key: 'gywm', name: '关于我们', url: '/company/about/' },
                ],
                compDetail: {},
                compMainBanner: '',
            }
        },
        computed: {
            // compMainBanner() {
            //     return CompService.getCompMainBanner(this.compID);
            // },
        },
        mounted() {
            this.getCompInfo();
        },
        methods: {
            async getCompInfo() {
                const res = await CompService.getCompanyInfo(this.compID);
                if (res.code === 0) {
                    const isWebsite = (res.data.info && res.data.info.isWebsite) ? 0 : 1;
                    if (!isWebsite) {
                        window.location.replace(`${location.origin}/exception/comp`)
                        return false;
                    }

                    // const status = (res.data.info && res.data.info.status === 0) ? 0 : 1;
                    // if (status == 0) {
                    //     window.location.replace(`${location.origin}/exception/vipexpire/${this.compID}`)
                    //     return false;
                    // }

                    const compState = Number(res.data.state);
                    if (compState == 9) {
                        window.location.replace(`${location.origin}/exception/vipexpire/${this.compID}`)
                        return false;
                    }

                    this.compDetail = res.data;
                    this.compMainBanner =`${ApiService.ImageHost}${res.data.CompanyBanner}`;
                    if (!location.pathname.includes('/product/detail')) {
                        document.title = this.$route.meta.title + '-' + res.data.CompName;
                    }
                    this.$emit('returnCompInfo', res.data);
                }
            },
        },
    }
</script>

<style lang="less" scoped>
    .comp-header{
        width: 100%;
        background-color: #ffffff;
        margin-bottom: 12px;
    }
    .header-content{
        width: 1200px;
        height: 120px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .banner-content{
        width: 100%;
        position: relative;
        font-size: 0;
        img{
            width: 100%;
        }
    }
    .mask{
        position: absolute!important;;
        width: 100%;
        height: 100%;
        background: #000;
        left: 0;
        top: 0;
        z-index: 0;
        opacity: 0.1;
    }
    .comp-detail{
        display: flex;
        flex: 1;
        align-items: center;
        p{
            margin: 0;
        }
    }
    .comp-name{
        max-width: 550px;
        margin-left: 12px;
    }
    .comp-name p{
        font-size: 16px;
    }
    .comp-name p:first-child{
        font-size: 32px;
        font-weight: bold;
        color: @a-color-active;
        margin-bottom: 8px;
    }
    .menu-view{
        display: flex;
        position: relative;
        flex-wrap: wrap;
        width: 320px;
    }
    .menu-item{
        height: 42px;
        line-height: 42px;
        padding: 0 10px;
        border-radius: 4px;
        font-size: 16px;
        margin-right: 10px;
        cursor: pointer;
        .m-tab-label{
            color: @main-color;
            text-decoration: none;
            display: block;
        }
    }
    .menu-item:hover{
        background-color: #1e50ae;
        .m-tab-label{
            color: #ffffff;
        }
    }
    .menu-item.active{
        background-color: #1e50ae;
        .m-tab-label{
            color: #ffffff;
        }
    }
    .comp-phone{
        font-size: 18px;
        color: #d81b43;
        font-weight: bold;
        width: 320px;
        margin-top: 12px;
    }
</style>
